import { render } from "./ArticleImage.vue?vue&type=template&id=7968dde3&scoped=true"
import script from "./ArticleImage.vue?vue&type=script&lang=js"
export * from "./ArticleImage.vue?vue&type=script&lang=js"

import "./ArticleImage.vue?vue&type=style&index=0&id=7968dde3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7968dde3"]])

export default __exports__